export enum LayerThicknessRoc {
  Micron50 = 50,
  Micron100 = 100,
  Micron170 = 170,
}
